import { css } from "@emotion/css";
import { useRef } from "react";
import { LIGHT_GREY, TURQUOISE } from "./colors";

export const Button = ({
  title,
  disabled,
  onClick,
}: {
  title: string;
  disabled?: boolean;
  onClick: () => void;
}) => {
  return (
    <button
      className={css(`
        all: unset;
        cursor: ${disabled ? "default" : "pointer"};
        padding: 12px;
        border-radius: 3px;
        background-color: ${disabled ? LIGHT_GREY.darken(1).hex() : TURQUOISE.darken(1.5).hex()};
        flex-shrink: 0;
        white-space: nowrap;

        &:hover {
          background-color: ${disabled ? LIGHT_GREY.darken(1).hex() : TURQUOISE.darken(1.5).hex()};
        }
        &:active {
          background-color: ${TURQUOISE.darken(2).hex()};
        }
    `)}
      onClick={() => !disabled && onClick()}
    >
      {title}
    </button>
  );
};
